import type { StateCreator } from 'zustand';

export type DisplayMode = 'stack' | 'canvas';
export type ThemeMode = 'light' | 'dark' | 'system';

/**
 * Settings Slice — пользовательские настройки отображения
 */
export interface SettingsSlice {
  displayMode: DisplayMode;
  setDisplayMode: (mode: DisplayMode) => void;
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => void;
}

export const createSettingsSlice: StateCreator<
  SettingsSlice,
  [],
  [],
  SettingsSlice
> = (set) => ({
  displayMode: 'stack',
  setDisplayMode: (mode) => set({ displayMode: mode }),
  themeMode: 'light',
  setThemeMode: (mode) => set({ themeMode: mode }),
});
